// extracted by mini-css-extract-plugin
export default {"cls1":"PaperSelector-cls1_aZ3","cls2":"PaperSelector-cls2_xcO PaperSelector-cls1_aZ3"};